import SignInContainer from './sign_in_container';

const SignIn = SignInContainer;
export default SignIn;
